import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SAVEFILE = function (state, payload) {
  state.ach = payload[0]
  state.melange = payload[1]
}
mutations.ACH = function (state, payload) {
  state.ach = payload
}
mutations.MELANGE = function (state, payload) {
  state.melange = payload
}

const state = {
  rows: [],
  row: null,
  condition: {},
  ach: [],
  melange: [],
  code: ''
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        ach: {api: 'M0201CmsPageManagementService.getFile'},
        melange: {api: 'M0201CmsPageManagementService.getFile2'}
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('ACH', data.ach.output)
        commit('MELANGE', data.melange.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'M0201CmsPageManagementService.getFile' } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          SysUtils.showInfo(SysUtils.MESSAGE.RECORD.NO_MATCH)
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'M0001UserService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'M0201CmsPageManagementService.deleteFile', input: row } } })
      .then((data) => {
        alert('Delete Successful')
        commit('SAVEFILE', data.delete.output)
      })
  },
  saveFile: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0201CmsPageManagementService.saveNewFile', input: row } } })
      .then((data) => {
        commit('SAVEFILE', data.save.output)
      })
  },
  saveFileContent: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'M0201CmsPageManagementService.saveFileContent', input: row } } })
      .then((data) => {
        alert('Content Saved')
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0001User download')
    return client.download({ data: { download: { api: 'M0001UserService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/PageManagement/PageManagementStore.js